import styled from 'styled-components';

import {
  subMenuDropdownBackground,
  primaryColorWeak,
  primaryColorStrong,
} from '../../config/colors';

export const WeightBreakdownWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  background-color: ${subMenuDropdownBackground};
  padding: 21px 20px 40px 20px;

  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;
    word-break: break-word;
  }

  thead {
    border: 2px solid ${primaryColorStrong};
    border-bottom: 0px;
    th {
      padding: 7px;
      border-right: 1px solid ${primaryColorStrong};
    }
    tr:first-child th {
      background-color: ${primaryColorWeak};
      border-bottom: 0.5px solid ${primaryColorStrong};
      font-weight: 500;
      font-size: 1.25rem;
    }
    tr:last-child th {
      border-top: 0px;
      background-color: whiteSmoke;
      font-size: 0.875rem;
    }
  }

  tbody {
    border: 2px solid ${primaryColorStrong};
    border-top: 0px;
    border-bottom: 0px;
    font-size: 0.875rem;
    background-color: white;
    
    th,
    td {
      margin: 0;
      border: 1px solid ${primaryColorStrong};
      border-top: 0px;
      border-bottom: 0px;
    }

    tr {
      border-bottom: 0px solid ${primaryColorStrong};
      border-top: 1px solid ${primaryColorStrong};
    }

    tr:last-child {
      border-bottom: 2px solid ${primaryColorStrong};
    }
  }

  td {
    font-weight: 500;
  }
`;
